// extracted by mini-css-extract-plugin
export var actionButton = "_q1-0";
export var actionMenuContainer = "_q1-i";
export var bubble = "_q1-2";
export var bubbleActionMenu = "_q1-j";
export var bubbleContext = "_q1-6";
export var bubbleItems = "_q1-7";
export var customer = "_q1-3";
export var divider = "_q1-8";
export var fileList = "_q1-9";
export var hiddenComment = "_q1-o";
export var infoAbove = "_q1-a";
export var internal = "_q1-4";
export var lightActionButton = "_q1-1";
export var link = "_q1-b";
export var merchant = "_q1-5";
export var message = "_q1-c";
export var profilePicture = "_q1-e";
export var quillToolbarContainer = "_q1-f";
export var senderDate = "_q1-g";
export var senderDateCustomer = "_q1-h";
export var senderName = "_q1-d";
export var time = "_q1-k";
export var uploadedImage = "_q1-l";
export var username = "_q1-m";
export var xsmall = "_q1-n";